import React from "react";
//#region Types
import { StyleEnums } from "models/enums";
import { AnnualReportSigningStepsFooterProps } from "models/propTypes/annualAccountPropTypes";
//#endregion
//#region Components
import { PageFooter } from "components/common";
import { annualReportSigned } from "store/actions/annualReportSigningStepsActions";
//#endregion
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { WintSuperkollAPIModel, WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";
import { useTodoService } from "serviceHooks";

const AnnualReportSigningStepsFooter: React.FC<AnnualReportSigningStepsFooterProps> = (props) => {
  const { annualAccountReport } = props;
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const todoService = useTodoService();

  const navigateToSigningPage = () => {
    let signingUrl = "https://arsredovisning.bolagsverket.se/arsredovisning-ingivning-web/";

    if (
      annualAccountReport?.state ===
      WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.AnnualReportSigningStarted
    ) {
      signingUrl = `https://app.oneflow.com/documents/${annualAccountReport.contract?.externalId}/at/${annualAccountReport.accessLink}`;
    } else if (
      annualAccountReport?.state ===
      WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.GeneralMeetingSigningStarted
    ) {
      signingUrl = `https://app.oneflow.com/documents/${annualAccountReport.contract?.externalId}/at/${annualAccountReport.accessLink}`;
    } else if (
      annualAccountReport?.state === WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.XbrlFileSubmitted
    ) {
      const snoozeUntil = new Date(Date.now() + 60 * 60 * 1000); // 1 hour from now
      todoService.snooze(annualAccountReport.id, WintSuperkollAPIModel.TodoType.AnnualReportSigningSteps, snoozeUntil);
    }

    window.open(signingUrl, "_blank");
    dispatch(annualReportSigned(annualAccountReport.id));
  };

  return (
    <PageFooter
      allowForReadOnlyUsers
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.GoToSigning),
          onClick: async () => {
            navigateToSigningPage();
          },
          type: StyleEnums.DisplayType.Info,
        },
      ]}
      showNavigateBack={props.showNavigateBack}
      disableSuccessMessages={props.disableSuccessMessages}
    />
  );
};

export default AnnualReportSigningStepsFooter;